module.exports = __webpack_public_path__ + "h5/img/bs_02.54b7c0cc.jpeg";